import type React from 'react';

import { FormField, FormHelp, Label, Text, Textarea } from '@zillow/constellation-10';

import type { Section } from '../../../models/index';
import { RECYCLING_PROCEDURES } from '../../../constants';

type Props = {
  section: Section;
  setSectionValues: (keyValuePairs: object) => void;
};

export default function RecyclingProcedure({ section, setSectionValues }: Props): JSX.Element {
  function onDescriptionChange(event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>): void {
    const { value } = event.currentTarget;

    setSectionValues({
      [RECYCLING_PROCEDURES.FIELD_NAME.DESCRIPTION]: value,
    });
  }

  return (
    <>
      <Text textStyle="body-lg-bold">Recycling procedures</Text>
      <FormField
        required
        css={{ marginTop: 'layout.tighter' }}
        label={<Label id="recycling-procedure-description">Describe the building recycling procedures</Label>}
        control={
          <Textarea
            aria-labelledby="recycling-procedure-description"
            onChange={onDescriptionChange}
            value={section.getFieldValue(RECYCLING_PROCEDURES.FIELD_NAME.DESCRIPTION)}
            css={{ resize: 'vertical' }}
          />
        }
        description={
          <FormHelp>
            This should include the location of recycling and composting areas, description of recycling and composting
            containers, how to discard large items and hazardous materials, and where to go for more information. These
            procedures apply to all residents, housekeepers, guests, subtenants, homecare workers, and other visitors.
          </FormHelp>
        }
      />
    </>
  );
}
